import { createSharedComposable, useStorage } from '@vueuse/core'
import { useCore } from '@/composables/core'
import { useEppo } from '@/composables/eppo'
import { useModal } from '@/composables/modal'

import { FEATURE_FLAGS } from '@/lib/consts'

import { useDailyClientQueue } from './daily-client-queue'

import PutPinModal from '@/components/turn-tracker/check-in-mode/put-pin-modal.vue'

function normalizeBusinessId (businessId) {
  const raw = String(businessId ?? 'unknown')
  return raw.replace(/[^a-zA-Z0-9_-]/g, '_')
}

export const useTurnTrackerCheckInMode = createSharedComposable(() => {
  const { router, store } = useCore()
  const businessId = store.state.business.business.id
  const country = store.state.app.country

  const business = normalizeBusinessId(`${country}-${businessId}`)

  const isCheckInModeFeatureAvailable = useEppo().ff(FEATURE_FLAGS.Feature_TurnTrackerCheckInMode)
  const { add, peek, removeFirst } = useDailyClientQueue(isCheckInModeFeatureAvailable, business)

  const addClientToQueue = (client) => {
    add({
      id: Date.now(),
      ...client,
    })
  }
  const getFirstClientFromQueue = peek
  const removeFirstClientFromQueue = removeFirst

  const storageKey = `tt-check-in-mode:biz:${business}`
  const isEnabled = useStorage(storageKey, false, localStorage, {
    mergeDefaults: true,
  })

  if (!isCheckInModeFeatureAvailable) {
    isEnabled.value = null
  }

  const modal = useModal()
  const disableCheckInMode = () => {
    modal.open({
      width: 450,
      content: {
        $component: {
          is: PutPinModal,
          '@resolve': () => {
            isEnabled.value = false
            modal.close()
            router.push({ name: 'turn-tracker.dashboard' })
          },
        },
      },
    })
  }

  const enableCheckInMode = () => {
    isEnabled.value = true
    router.push({ name: 'turn-tracker.check-in-mode' })
  }

  return {
    addClientToQueue,
    getFirstClientFromQueue,
    removeFirstClientFromQueue,
    disableCheckInMode,
    enableCheckInMode,
    isEnabled,
    isCheckInModeFeatureAvailable,
  }
})
